import { t } from 'i18next';
import React from 'react';
import ModalDialog from '../../common/ModalDialog';

export type ConfirmAlertProps = {
    showAlert: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    alertText: string;
};

const ConfirmAlert = ({
    showAlert,
    onConfirm,
    onCancel,
    alertText
}: ConfirmAlertProps): JSX.Element => {
    return (
        <ModalDialog
            showDialog={showAlert}
            title={t('confirm_cancel')}
            primaryButton={{
                text: t('confirm'),
                disabled: false,
                onClick: onConfirm
            }}
            secondaryButton={{
                text: t('cancel'),
                onClick: onCancel
            }}
            onCloseClick={onCancel}>
            {alertText}
        </ModalDialog>
    );
};

export default ConfirmAlert;
